import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import RoomIcon from "@material-ui/icons/Room";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Maps from "../../../components/molecules/Maps";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import { isMobilePhoneId } from "../../../utils/isMobilePhone";

import { auth, GeoPoint } from "../../../components/firebase/FirebaseProvider";
import ImageGelombang from "../../../assets/images/login-gelombang.svg";
import Navbar from "../../../components/molecules/navbarLogReg";
import ImageFamily from "../../../assets/images/family.svg";
import useStyles from "./style";
import { Autocomplete } from "@material-ui/lab";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router";
import { CircularProgress } from "@material-ui/core";
import {
  BusinessOutlined,
  CreateOutlined,
  PersonOutlineOutlined,
  PhoneOutlined,
} from "@material-ui/icons";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
// import { Redirect } from "react-router-dom";

const NumberFormatCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "+",
        /[1-9]/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={false}
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default function Form() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("951"));
  const matches1 = useMediaQuery(theme.breakpoints.up("1156"));
  const [year] = useState(new Date().getFullYear());

  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const { alamatRef, profilRef, alamat_pusat } = useData();
  const [currentPos, setCurrentPos] = useState(null);
  const position = {
    lat: alamat_pusat?.koordinat?.latitude,
    lng: alamat_pusat?.koordinat?.longitude,
  };
  // console.log("ini",alamat);
  const [values, setValues] = useState({
    judul: "",
    nama_penerima: "",
    no_telepon: "",
    provinsi: "",
    kota: "",
    kecamatan: "",
    kelurahan: "",
    alamat_lengkap: "",
    destination_direction: "",
  });

  useEffect(() => {
    if (values?.kota?.id === alamat_pusat?.kota?.id) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          setCurrentPos({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        });
      } else {
        enqueueSnackbar("Geolocation tidak di dukung oleh browser ini", {
          variant: "error",
        });
      }
    }
  }, [alamat_pusat.kota.id, enqueueSnackbar, values.kota.id]);

  const [error, setError] = useState({
    judul: "",
    no_telepon: "",
    nama_penerima: "",
    provinsi: "",
    kota: "",
    kecamatan: "",
    kelurahan: "",
    alamat_lengkap: "",
  });

  const handleChange = (e) => {
    const value = e.target.value;

    setValues({
      ...values,
      [e.target.name]: value,
    });

    setError({
      ...error,
      [e.target.name]: "",
    });
  };

  const [provinsi, setProvinsi] = useState([]);
  useEffect(() => {
    async function fetchProvinsi() {
      try {
        const getProvinsi = firefunctions.httpsCallable("getProvinsi");

        const response = await getProvinsi();

        setProvinsi(response.data);
      } catch (e) {
        console.log(e.message);
      }
    }

    fetchProvinsi();
  }, []);

  const [kota, setKota] = useState([]);
  useEffect(() => {
    setValues((values) => ({
      ...values,
      kota: "",
      kecamatan: "",
      kelurahan: "",
    }));

    async function fetchKota() {
      try {
        const getKota = firefunctions.httpsCallable("getKota");

        if (values.provinsi.id) {
          const response = await getKota({ provinsi_id: values?.provinsi?.id });

          setKota(response.data);
        }
      } catch (e) {
        console.log(e.message);
      }
    }

    fetchKota();
  }, [values.provinsi.id]);

  const [kecamatan, setKecamatan] = useState([]);
  useEffect(() => {
    setValues((values) => ({
      ...values,
      kecamatan: "",
      kelurahan: "",
    }));

    async function fetchKecamatan() {
      try {
        const getKecamatan = firefunctions.httpsCallable("getKecamatan");

        if (values.kota.id) {
          const response = await getKecamatan({
            kota_id: values?.kota?.id,
            provinsi_id: values?.provinsi?.id,
          });

          setKecamatan(response.data);
        }
      } catch (e) {
        console.log(e.message);
      }
    }

    fetchKecamatan();
  }, [values.kota.id, values?.provinsi?.id]);

  const [kelurahan, setKelurahan] = useState([]);
  useEffect(() => {
    setValues((values) => ({
      ...values,
      kelurahan: "",
    }));

    async function fetchKelurahan() {
      try {
        const getKelurahan = firefunctions.httpsCallable("getKelurahan");

        if (values.kecamatan.id) {
          const response = await getKelurahan({
            kecamatan_id: values?.kecamatan?.id,
            kota_id: values?.kota?.id,
            provinsi_id: values?.provinsi?.id,
          });

          setKelurahan(response.data);
        }
      } catch (e) {
        console.log(e.message);
      }
    }

    fetchKelurahan();
  }, [values.kecamatan.id]);

  const [isSubmitting, setSubmitting] = useState(false);

  const validate = async () => {
    let exp = /-/g;
    const newError = { ...error };
    if (!values.judul) {
      newError.judul = "Judul harus diisi";
    }
    if (!values.nama_penerima) {
      newError.nama_penerima = "Nama harus diisi";
    }
    if (!values.no_telepon) {
      newError.no_telepon = "No Telpon harus diisi";
    } else if (!isMobilePhoneId(values.no_telepon.replace(exp, ""))) {
      newError.no_telepon = "No Telpon tidak valid";
    }
    if (!values.provinsi) {
      newError.provinsi = "Provinsi harus diisi";
    }
    if (!values.kota) {
      newError.kota = "Kota harus diisi";
    }
    if (!values.kecamatan) {
      newError.kecamatan = "Kecamatan harus diisi";
    }
    if (!values.kelurahan) {
      newError.kelurahan = "Kelurahan harus diisi";
    }
    if (!values.alamat_lengkap) {
      newError.alamat_lengkap = "Alamat Lengkap harus diisi";
    }
    return newError;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let exp = /-/g;
    const findError = await validate();

    console.log(findError);
    if (Object.values(findError).some((m) => m !== "")) {
      setError(findError);
    } else {
      // console.log({ ...values });
      setSubmitting(true);
      try {
        const { no_telepon } = values;
        const newPhone = no_telepon.replace(exp, "");
        const data =
          values?.kota?.id === alamat_pusat?.kota?.id
            ? {
                ...values,
                no_telepon: newPhone,
                koordinat: new GeoPoint(currentPos?.lat, currentPos?.lng),
                created_at: Date.now(),
                updated_at: Date.now(),
                type: "web-reseller",
              }
            : {
                ...values,
                no_telepon: newPhone,
                created_at: Date.now(),
                updated_at: Date.now(),
                type: "web-reseller",
              };

        // const newAlamat = await alamatRef.add({
        //   ...values,
        //   // koordinat: form.koordinat ?? "",
        // });

        const newAlamat = await alamatRef.add(data);
        await profilRef.set({ alamat_utama: newAlamat.id }, { merge: true });

        enqueueSnackbar("Alamat Berhasi ditambahkan", { variant: "success" });
        history.replace(`/`);
      } catch (e) {
        const newError = {};
        newError.title = e.message;

        setError(newError);
      }
      setSubmitting(false);
    }
  };

  const handleSignOut = async () => {
    await auth.signOut();
  };

  // useEffect(() => {
  //   if (profil?.alamat_utama) {
  //     history.push(`/`);
  //   }
  // }, []);

  return (
    <div>
      <div className={classes.header}>
        <Navbar />
        <div>
          <div>
            <img
              src={ImageGelombang}
              alt="icon"
              className={classes.gelombang}
            />
          </div>
          {matches1 ? (
            <div
              style={{
                margin: "5%",
                marginLeft: "10%",
              }}
            >
              <img
                src={ImageFamily}
                alt="icon"
                style={{ width: "30%", position: "absolute", marginLeft: -40 }}
              />
            </div>
          ) : null}
          <div>
            <div className={classes.content}>
              <div className={classes.boxContent}>
                <div className={classes.textContent3}>
                  <h4 className={classes.textContent3H4}>Alamat Utama Toko</h4>
                </div>
                <div className={classes.garisContent} />
                <values noValidate>
                  {matches ? (
                    <div>
                      <div style={{ display: "flex", marginLeft: 10 }}>
                        <FormControl
                          style={{
                            margin: theme.spacing(1),
                            width: "50%",
                          }}
                        >
                          <InputLabel
                            style={{
                              marginLeft: 15,
                              marginTop: -5,
                              backgroundColor: "white",
                            }}
                          >
                            Judul
                          </InputLabel>
                          <OutlinedInput
                            label="Judul"
                            id="judul"
                            name="judul"
                            disabled={isSubmitting}
                            placeholder="Rumah"
                            error={error.judul ? true : false}
                            onChange={handleChange}
                            value={values.judul}
                            startAdornment={
                              <InputAdornment position="start">
                                <CreateOutlined color="action" />
                              </InputAdornment>
                            }
                            labelWidth={0}
                            style={{ height: 40 }}
                          />
                        </FormControl>
                        <FormControl style={{ width: "50%", marginRight: 20 }}>
                          <Autocomplete
                            id="provinsi"
                            name="provinsi"
                            required
                            disableClearable
                            value={values.provinsi}
                            onChange={(event, value) => {
                              handleChange({
                                target: { name: "provinsi", value },
                              });
                            }}
                            disabled={isSubmitting}
                            options={provinsi}
                            getOptionLabel={(option) =>
                              option.name ? option.name : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                margin="dense"
                                {...params}
                                label="Provinsi"
                                InputLabelProps={{ shrink: true }}
                                // helperText={error?.provinsi}
                                error={error?.provinsi ? true : false}
                                variant="outlined"
                              />
                            )}
                          />
                        </FormControl>
                      </div>
                      <div style={{ display: "flex", marginLeft: 11 }}>
                        <FormControl
                          style={{
                            margin: theme.spacing(1),
                            width: "21%",
                          }}
                        >
                          <InputLabel style={{ marginLeft: 15, marginTop: -5 }}>
                            Penerima
                          </InputLabel>
                          <OutlinedInput
                            label="Penerima"
                            id="nama_penerima"
                            name="nama_penerima"
                            disabled={isSubmitting}
                            onChange={handleChange}
                            required
                            error={error.nama_penerima ? true : false}
                            value={values.nama_penerima}
                            placeholder="Teddi"
                            startAdornment={
                              <InputAdornment position="start">
                                <PersonOutlineOutlined color="action" />
                              </InputAdornment>
                            }
                            labelWidth={0}
                            style={{ height: 42 }}
                          />
                        </FormControl>
                        <FormControl
                          style={{
                            marginTop: 8,
                            width: "25%",
                          }}
                        >
                          <InputLabel style={{ marginLeft: 15, marginTop: -5 }}>
                            No Telp
                          </InputLabel>
                          <OutlinedInput
                            label="No Telp"
                            required
                            placeholder="+62-899-2346-764"
                            id="no_telepon"
                            name="no_telepon"
                            disabled={isSubmitting}
                            onChange={handleChange}
                            error={error.no_telepon ? true : false}
                            value={values.no_telepon}
                            startAdornment={
                              <InputAdornment position="start">
                                <PhoneOutlined color="action" />
                              </InputAdornment>
                            }
                            labelWidth={0}
                            style={{ height: 42, width: "110%" }}
                            inputComponent={NumberFormatCustom}
                          />
                        </FormControl>
                        <FormControl
                          style={{
                            width: "50%",
                            marginRight: 20,
                            marginLeft: 25,
                          }}
                        >
                          <Autocomplete
                            id="kota"
                            name="kota"
                            disableClearable
                            required
                            value={values.kota}
                            onChange={(event, value) => {
                              handleChange({ target: { name: "kota", value } });
                            }}
                            disabled={isSubmitting}
                            options={kota}
                            getOptionLabel={(option) =>
                              option.name ? option.name : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                margin="dense"
                                {...params}
                                label="Kota"
                                InputLabelProps={{ shrink: true }}
                                // helperText={error?.kota}
                                error={error?.kota ? true : false}
                                variant="outlined"
                              />
                            )}
                          />
                        </FormControl>
                        <div></div>
                      </div>
                      <div style={{ display: "flex", marginLeft: 10 }}>
                        <FormControl
                          style={{
                            margin: theme.spacing(1),
                            width: "50%",
                          }}
                        >
                          {values?.kota?.id === alamat_pusat?.kota?.id ? (
                            <>
                              <InputLabel
                                style={{ marginLeft: 15, marginTop: -5 }}
                              >
                                Titik Map
                              </InputLabel>
                              <OutlinedInput
                                disabled={true}
                                required
                                placeholder="-6.895840685106305"
                                error={error.judul ? true : false}
                                onChange={handleChange}
                                value={
                                  !currentPos?.lat
                                    ? "Pilih Titik Map"
                                    : currentPos?.lat + currentPos?.lng
                                }
                                startAdornment={
                                  <InputAdornment position="start">
                                    <RoomIcon />
                                  </InputAdornment>
                                }
                                labelWidth={80}
                                style={{ height: 40 }}
                              />
                            </>
                          ) : null}
                        </FormControl>
                        <FormControl style={{ width: "50%", marginRight: 20 }}>
                          <Autocomplete
                            id="kecamatan"
                            name="kecamatan"
                            disableClearable
                            required
                            value={values.kecamatan}
                            onChange={(event, value) => {
                              handleChange({
                                target: { name: "kecamatan", value },
                              });
                            }}
                            disabled={isSubmitting}
                            options={kecamatan}
                            getOptionLabel={(option) =>
                              option.name ? option.name : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                margin="dense"
                                {...params}
                                label="Kecamatan"
                                InputLabelProps={{ shrink: true }}
                                // helperText={error?.kecamatan}
                                error={error?.kecamatan ? true : false}
                                variant="outlined"
                              />
                            )}
                          />
                        </FormControl>
                      </div>
                      <div style={{ display: "flex", marginLeft: 10 }}>
                        <FormControl
                          style={{
                            margin: theme.spacing(1),
                            width: "50%",
                          }}
                        >
                          {values?.kota?.id === alamat_pusat?.kota?.id && (
                            <Maps
                              center={position}
                              currentPos={currentPos}
                              setCurrentPos={setCurrentPos}
                            />
                          )}
                        </FormControl>
                        <FormControl style={{ width: "50%", marginRight: 20 }}>
                          <Autocomplete
                            id="kelurahan"
                            name="kelurahan"
                            disableClearable
                            required
                            value={values.kelurahan}
                            onChange={(event, value) => {
                              handleChange({
                                target: { name: "kelurahan", value },
                              });
                            }}
                            disabled={isSubmitting}
                            options={kelurahan}
                            getOptionLabel={(option) =>
                              option.name ? option.name : ""
                            }
                            renderInput={(params) => (
                              <TextField
                                margin="dense"
                                {...params}
                                label="Kelurahan"
                                InputLabelProps={{ shrink: true }}
                                // helperText={error?.kelurahan}
                                error={error?.kelurahan ? true : false}
                                variant="outlined"
                              />
                            )}
                          />
                        </FormControl>
                      </div>

                      <div style={{ display: "flex", marginLeft: 10 }}>
                        <FormControl
                          style={{
                            margin: theme.spacing(1),
                            width: "50%",
                          }}
                        ></FormControl>
                        <FormControl
                          style={{
                            width: "50%",
                            marginRight: 20,
                            marginTop:
                              values.kota.id === alamat_pusat?.kota?.id
                                ? -100
                                : 10,
                          }}
                        >
                          <InputLabel style={{ marginLeft: 15, marginTop: -5 }}>
                            Alamat Lengkap
                          </InputLabel>
                          <OutlinedInput
                            label="Alamat Lengkap"
                            id="alamat_lengkap"
                            name="alamat_lengkap"
                            disabled={isSubmitting}
                            error={error.alamat_lengkap ? true : false}
                            value={values.alamat_lengkap}
                            onChange={handleChange}
                            variant="outlined"
                            placeholder="Jln. Tegal Antapani Kidul"
                            startAdornment={
                              <InputAdornment position="start">
                                <BusinessOutlined color="action" />
                              </InputAdornment>
                            }
                            labelWidth={90}
                            style={{ height: 40 }}
                          />
                        </FormControl>
                      </div>

                      <div style={{ display: "flex", marginLeft: 10 }}>
                        <FormControl
                          style={{
                            margin: theme.spacing(1),
                            width: "50%",
                          }}
                        ></FormControl>
                        <FormControl
                          style={{
                            width: "50%",
                            marginRight: 20,
                            marginTop:
                              values.kota.id === alamat_pusat?.kota?.id
                                ? -60
                                : 15,
                          }}
                        >
                          <InputLabel style={{ marginLeft: 15, marginTop: -5 }}>
                            Patokan (Opsional)
                          </InputLabel>
                          <OutlinedInput
                            label="Patokan (Opsional)"
                            id="destination_direction"
                            name="destination_direction"
                            disabled={isSubmitting}
                            error={error.destination_direction ? true : false}
                            value={values.destination_direction}
                            onChange={handleChange}
                            variant="outlined"
                            placeholder="Depan Masjid Al-huda"
                            startAdornment={
                              <InputAdornment position="start">
                                <HomeOutlinedIcon color="action" />
                              </InputAdornment>
                            }
                            labelWidth={90}
                            style={{ height: 40 }}
                          />
                        </FormControl>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          marginRight: 20,
                          justifyContent: "flex-end",
                          marginTop:
                            values.kota.id === alamat_pusat?.kota?.id
                              ? -30
                              : 10,
                        }}
                      >
                        <Button
                          color="primary"
                          variant="outlined"
                          className={classes.formBottom}
                          style={{ marginRight: 15, width: "18%" }}
                          onClick={handleSignOut}
                        >
                          Sign Out
                        </Button>
                        <Button
                          variant="contained"
                          disabled={
                            isSubmitting ||
                            values.judul === "" ||
                            values.nama_penerima === "" ||
                            values.no_telepon === ""
                          }
                          color="primary"
                          className={classes.formBottom}
                          style={{ width: "28%" }}
                          onClick={handleSubmit}
                        >
                          Simpan
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <values noValidate>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        style={{ width: "90%" }}
                      >
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{
                            color: "rgba(0, 0, 0, 0.54)",
                          }}
                          slot="true"
                        >
                          Judul
                        </InputLabel>
                        <OutlinedInput
                          label="Judul"
                          id="judul"
                          name="judul"
                          disabled={isSubmitting}
                          placeholder="Rumah Alkaf"
                          required
                          error={error.judul ? true : false}
                          onChange={handleChange}
                          value={values.judul}
                          startAdornment={
                            <InputAdornment position="start">
                              <CreateOutlined color="action" />
                            </InputAdornment>
                          }
                          labelWidth={45}
                        />
                      </FormControl>
                      <p
                        style={{
                          fontSize: "9px",
                          color: "red",
                          alignItems: "center",
                          textAlign: "left",
                          marginTop: 0,
                          marginBottom: 0,
                          marginLeft: "5%",
                          display: "flex",
                          fontWeight: "500",
                          width: "350px",
                        }}
                      >
                        {error.judul}
                      </p>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        style={{ width: "90%", marginTop: 10 }}
                      >
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{
                            color: "rgba(0, 0, 0, 0.54)",
                          }}
                          slot="true"
                        >
                          Nama Penerima
                        </InputLabel>
                        <OutlinedInput
                          label="Nama Penerima"
                          id="nama_penerima"
                          name="nama_penerima"
                          disabled={isSubmitting}
                          onChange={handleChange}
                          required
                          error={error.nama_penerima ? true : false}
                          // helperText={error.nama_penerima}
                          value={values.nama_penerima}
                          placeholder="Teddi rahman"
                          startAdornment={
                            <InputAdornment position="start">
                              <PersonOutlineOutlined color="action" />
                            </InputAdornment>
                          }
                          labelWidth={0}
                        />
                      </FormControl>
                      <p
                        style={{
                          fontSize: "9px",
                          color: "red",
                          alignItems: "center",
                          textAlign: "left",
                          marginTop: 0,
                          marginBottom: 0,
                          marginLeft: "5%",
                          display: "flex",
                          fontWeight: "500",
                          width: "350px",
                        }}
                      >
                        {error.nama_penerima}
                      </p>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        style={{ width: "90%", marginTop: 10 }}
                      >
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{
                            color: "rgba(0, 0, 0, 0.54)",
                          }}
                          slot="true"
                        >
                          No Telp
                        </InputLabel>
                        <OutlinedInput
                          label="No Telp"
                          required
                          placeholder="+62-81-2346-7642"
                          id="no_telepon"
                          name="no_telepon"
                          disabled={isSubmitting}
                          onChange={handleChange}
                          error={error.no_telepon ? true : false}
                          value={values.no_telepon}
                          startAdornment={
                            <InputAdornment position="start">
                              <PhoneOutlined color="action" />
                            </InputAdornment>
                          }
                          labelWidth={0}
                          inputComponent={NumberFormatCustom}
                        />
                      </FormControl>
                      <p
                        style={{
                          fontSize: "9px",
                          color: "red",
                          alignItems: "center",
                          textAlign: "left",
                          marginTop: 0,
                          marginBottom: -5,
                          marginLeft: "5%",
                          display: "flex",
                          fontWeight: "500",
                          width: "350px",
                        }}
                      >
                        {error.no_telepon}
                      </p>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        style={{ width: "90%", marginTop: 10 }}
                      >
                        <Autocomplete
                          id="provinsi"
                          name="provinsi"
                          required
                          disableClearable
                          value={values.provinsi}
                          onChange={(event, value) => {
                            handleChange({
                              target: { name: "provinsi", value },
                            });
                          }}
                          disabled={isSubmitting}
                          options={provinsi}
                          getOptionLabel={(option) =>
                            option.name ? option.name : ""
                          }
                          renderInput={(params) => (
                            <TextField
                              margin="dense"
                              {...params}
                              label="Provinsi"
                              InputLabelProps={{ shrink: true }}
                              // helperText={error?.provinsi}
                              error={error?.provinsi ? true : false}
                              variant="outlined"
                            />
                          )}
                        />
                      </FormControl>
                      <p
                        style={{
                          fontSize: "9px",
                          color: "red",
                          alignItems: "center",
                          textAlign: "left",
                          marginTop: -5,
                          marginBottom: -5,
                          marginLeft: "5%",
                          display: "flex",
                          fontWeight: "500",
                          width: "350px",
                        }}
                      >
                        {error.provinsi}
                      </p>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        style={{ width: "90%", marginTop: 10 }}
                      >
                        <Autocomplete
                          id="kota"
                          name="kota"
                          disableClearable
                          required
                          value={values.kota}
                          onChange={(event, value) => {
                            handleChange({ target: { name: "kota", value } });
                          }}
                          disabled={isSubmitting}
                          options={kota}
                          getOptionLabel={(option) =>
                            option.name ? option.name : ""
                          }
                          renderInput={(params) => (
                            <TextField
                              margin="dense"
                              {...params}
                              label="Kota"
                              InputLabelProps={{ shrink: true }}
                              // helperText={error?.kota}
                              error={error?.kota ? true : false}
                              variant="outlined"
                            />
                          )}
                        />
                      </FormControl>
                      <p
                        style={{
                          fontSize: "9px",
                          color: "red",
                          alignItems: "center",
                          textAlign: "left",
                          marginTop: -5,
                          marginBottom: -5,
                          marginLeft: "5%",
                          display: "flex",
                          fontWeight: "500",
                          width: "350px",
                        }}
                      >
                        {error.kota}
                      </p>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        style={{ width: "90%", marginTop: 10 }}
                      >
                        <Autocomplete
                          id="kecamatan"
                          name="kecamatan"
                          disableClearable
                          required
                          value={values.kecamatan}
                          onChange={(event, value) => {
                            handleChange({
                              target: { name: "kecamatan", value },
                            });
                          }}
                          disabled={isSubmitting}
                          options={kecamatan}
                          getOptionLabel={(option) =>
                            option.name ? option.name : ""
                          }
                          renderInput={(params) => (
                            <TextField
                              margin="dense"
                              {...params}
                              label="Kecamatan"
                              InputLabelProps={{ shrink: true }}
                              // helperText={error?.kecamatan}
                              error={error?.kecamatan ? true : false}
                              variant="outlined"
                            />
                          )}
                        />
                      </FormControl>
                      <p
                        style={{
                          fontSize: "9px",
                          color: "red",
                          alignItems: "center",
                          textAlign: "left",
                          marginTop: -5,
                          marginBottom: -5,
                          marginLeft: "5%",
                          display: "flex",
                          fontWeight: "500",
                          width: "350px",
                        }}
                      >
                        {error.kecamatan}
                      </p>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        style={{ width: "90%", marginTop: 10 }}
                      >
                        <Autocomplete
                          id="kelurahan"
                          name="kelurahan"
                          disableClearable
                          required
                          value={values.kelurahan}
                          onChange={(event, value) => {
                            handleChange({
                              target: { name: "kelurahan", value },
                            });
                          }}
                          disabled={isSubmitting}
                          options={kelurahan}
                          getOptionLabel={(option) =>
                            option.name ? option.name : ""
                          }
                          renderInput={(params) => (
                            <TextField
                              margin="dense"
                              {...params}
                              label="Kelurahan"
                              InputLabelProps={{ shrink: true }}
                              // helperText={error?.kelurahan}
                              error={error?.kelurahan ? true : false}
                              variant="outlined"
                            />
                          )}
                        />
                      </FormControl>
                      <p
                        style={{
                          fontSize: "9px",
                          color: "red",
                          alignItems: "center",
                          textAlign: "left",
                          marginTop: -5,
                          marginBottom: 5,
                          marginLeft: "5%",
                          display: "flex",
                          fontWeight: "500",
                          width: "350px",
                        }}
                      >
                        {error.kelurahan}
                      </p>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        style={{ width: "90%", marginTop: 10 }}
                      >
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{
                            color: "rgba(0, 0, 0, 0.54)",
                          }}
                          slot="true"
                        >
                          Alamat Lengkap
                        </InputLabel>
                        <OutlinedInput
                          id="alamat_lengkap"
                          name="alamat_lengkap"
                          label="alamat_lengkap"
                          disabled={isSubmitting}
                          onChange={handleChange}
                          required
                          error={error.alamat_lengkap ? true : false}
                          // helperText={error.alamat_lengkap}
                          value={values.alamat_lengkap}
                          placeholder="Jln. Tegal Antapani Kidul"
                          startAdornment={
                            <InputAdornment position="start">
                              <BusinessOutlined color="action" />
                            </InputAdornment>
                          }
                          labelWidth={0}
                        />
                      </FormControl>
                      <p
                        style={{
                          fontSize: "9px",
                          color: "red",
                          alignItems: "center",
                          textAlign: "left",
                          marginTop: 0,
                          marginBottom: 0,
                          marginLeft: "5%",
                          display: "flex",
                          fontWeight: "500",
                          width: "350px",
                        }}
                      >
                        {error.alamat_lengkap}
                      </p>
                      <FormControl
                        margin="dense"
                        variant="outlined"
                        style={{ width: "90%", marginTop: 10 }}
                      >
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{
                            color: "rgba(0, 0, 0, 0.54)",
                          }}
                          slot="true"
                        >
                          Patokan (Opsional)
                        </InputLabel>
                        <OutlinedInput
                          id="destination_direction"
                          name="destination_direction"
                          label="Patokan (Opsional)"
                          disabled={isSubmitting}
                          onChange={handleChange}
                          required
                          error={error.destination_direction ? true : false}
                          // helperText={error.destination_direction}
                          value={values.destination_direction}
                          placeholder="Depan Masjid Al-Huda"
                          startAdornment={
                            <InputAdornment position="start">
                              <HomeOutlinedIcon color="action" />
                            </InputAdornment>
                          }
                          labelWidth={0}
                        />
                      </FormControl>

                      {values?.kota?.id === alamat_pusat?.kota?.id ? (
                        <>
                          <div style={{ marginTop: 10 }}>
                            <FormControl
                              style={{
                                margin: theme.spacing(1),
                                width: "90%",
                              }}
                            >
                              <InputLabel
                                style={{ marginLeft: 15, marginTop: -5 }}
                              >
                                Titik Map
                              </InputLabel>
                              <OutlinedInput
                                disabled={true}
                                placeholder="Rumah"
                                error={error.judul ? true : false}
                                onChange={handleChange}
                                value={
                                  !currentPos?.lat
                                    ? "Pilih Titik Map"
                                    : currentPos?.lat + currentPos?.lng
                                }
                                startAdornment={
                                  <InputAdornment position="start">
                                    <RoomIcon />
                                  </InputAdornment>
                                }
                                labelWidth={80}
                                style={{ height: 40 }}
                              />
                              {values?.kota?.id === alamat_pusat?.kota?.id && (
                                <Maps
                                  center={position}
                                  currentPos={currentPos}
                                  setCurrentPos={setCurrentPos}
                                />
                              )}
                            </FormControl>
                          </div>
                        </>
                      ) : null}
                      <Button
                        variant="contained"
                        size="small"
                        disabled={isSubmitting}
                        color="primary"
                        className={classes.formBottom}
                        onClick={handleSubmit}
                      >
                        {isSubmitting === true ? (
                          <CircularProgress
                            size={24}
                            style={{ color: "#5675D3" }}
                          />
                        ) : (
                          "Simpan"
                        )}
                      </Button>
                      <Button
                        color="primary"
                        className={classes.formBottom}
                        onClick={handleSignOut}
                      >
                        Sign Out
                      </Button>
                      <div style={{ height: "20px" }} />
                    </values>
                  )}
                </values>
              </div>
            </div>
            <div className={classes.textCopyright}>
              {matches1 ? (
                <h5 className={classes.textCopyrightH5}>
                  Copyright © TokoRame {year}
                </h5>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
